<template>
	<v-container>
		<v-row
			v-if="false"
			align="center"
			justify="space-around"
		>
			<v-btn>
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Operacion
			</v-btn>
			<v-btn color="primary">
				<v-icon>
					mdi-cloud-upload
				</v-icon>
				Limites
			</v-btn>
		</v-row>
		<v-alert
			v-if="false"
			dense
			outlined
			type="error"
		>
			No se encuentran <strong>datos</strong> para el dia <strong> {{viewDate | dateFormat}} </strong>
		</v-alert>
		<v-row>
			<v-col
				cols="12"
				sm="5"
				v-if="showProjects"
			>
				<v-select
					v-model="selectProject"
					:items="projects"
					item-text="name"
					item-value="projectId"
					chips
					label="Proyectos"
					outlined
				></v-select>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-select
					v-model="selectDevices"
					:items="devices"
					item-text="name"
					item-value="deviceId"
					chips
					label="Dispositivos"
					multiple
					outlined
				>
					<template #selection="{ item }">
						<v-chip dark :color="colorChip(item)">{{item.name}}</v-chip>
					</template>
				</v-select>
			</v-col>
			<v-col
				cols="12"
				sm="6"
			>
				<v-btn
					style="margin-top: 15px;"
					depressed
					color="primary"
					@click="getDevicesData"
				>
					Comparar
				</v-btn>
			</v-col>
			<v-col cols="12" v-show="isLoading">
				<v-skeleton-loader
					type="image"
				></v-skeleton-loader>
				<v-skeleton-loader
					type="image"
				></v-skeleton-loader>
			</v-col>
			<v-col cols="12" v-show="!isLoading">
				<apexchart ref="chart" height="400px" :options="options" :series="series"></apexchart>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import moment from 'moment'
	import VueApexCharts from 'vue-apexcharts'
	import colors from '@/constants/colorPalette.js'

	export default {
		name: 'Compare',

		data: () => ({
            options: {
				colors: colors.CHART_COLORS,
				markers: {
					showNullDataPoints: false,
				},
				stroke: {
					width: 2,
					curve: 'straight'
				},
				chart: {
					type: 'line',
					id: 'hA',
					group: 'social',
					animations: {
						enabled: false
					},
				},
				yaxis: {
					labels: {
						minWidth: 0,
						formatter: function (value) {
							return value.toFixed(1) + ""
						}
					},
					title: {
						text: 'Decibeles [dBA]',
					},
				},
				annotations: {
					xaxis: [],
					points: []
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 1,
					labels: {
						show: true,
						datetimeUTC: false,
						format: 'HH:mm:ss',
					}
				},
				tooltip: {
					x: {
						format: "HH:mm:ss"
					}
				},
            },
			series: [],
			Laeqfs: [],
			selectDevices:[],
			selectProject: []
        }),
		
		methods: {
			getDevicesData () {
				const payload = {
					devices: this.selectDevices,
					date: this.viewDate
				}

				this.$store.dispatch('handleLoading', true)
				this.$store.dispatch('pullDeviceDateCompare', payload)
			},

			dataCharts (data) {
				this.options.annotations.xaxis = []
				this.options.annotations.points = []
				
				this.$refs.chart.updateOptions({
					annotations: {
						points: [],
						xaxis: []
					}
				})

				this.series = []

				for (let j = 0; j < data.length; j++) {
					let Laeqfs = []
					const devicesInfo = this.findDeviceInfo(data[j].deviceId)

					const laeqSensor = devicesInfo.sensors.find( e => {
						return e.sensorType === 'laeq'
					}).sensorName
	
					let offsetloco = this.laeqOffset (data[j].deviceId, laeqSensor)
					const info = data[j].info

					if (info.length === 0)
						continue

					for (let i = 0; i < info.length; i++) {
						const laqeValue = info[i].report.avg + offsetloco
						let laqeValuePre = laqeValue

						if (i > 0)
							laqeValuePre = info[i - 1].report.avg + offsetloco
						
						let laeqSensorValue
						let laeqFilter

						if (!Object.hasOwnProperty.call(devicesInfo, "laeqFilter")) {
							laeqFilter = {
								max: 100,
								min: 0
							}
						} else {
							laeqFilter = devicesInfo.laeqFilter
						}

						if (laqeValue > laeqFilter.max || laqeValue < laeqFilter.min)
							laeqSensorValue = null
						else 
							laeqSensorValue = laqeValue

						Laeqfs.push({
							str: info[i].ts,
							x: new Date(info[i].ts).getTime(),
							y: laeqSensorValue
						})
					}

					this.series.push({
						type: 'line',
						name: `Nivel sonoro equivalente ${devicesInfo.name}`,
						color: devicesInfo.info.color,
						data: Laeqfs,
						_p: devicesInfo.info.displayRank
					})
				}

				this.series.sort((a, b) => b._p - a._p)
				this.$store.dispatch('handleLoading', false)
			},

			laeqOffset (deviceId, sensorName) {
				const findSensor = this.allSensors.filter( sensor => sensor.deviceId === deviceId && sensor.sensorName === sensorName )

				if (findSensor.length > 0)
					return findSensor[0].offset

				return 0
			},

			findDeviceInfo (deviceId) {
				return this.$store.getters.device(deviceId)
			},

			colorChip (item) {
				if ( ('info' in item ) && ( 'color' in item.info))
					return item.info.color

				let index = this.selectDevices.indexOf(item.deviceId)
				return this.options.colors[index]
			}
		},

		computed: {
			viewDate () {
				return this.$store.getters.viewDate
			},

			isLoading () {
				return this.$store.getters.isLoading
			},

			devices () {
				return this.$store.getters.devices
			},

			dayReport () {
                return moment(this.devicesDateCompare.date).format("YYYY-MM-DD") 
			},

			devicesDateCompare () {
                return this.$store.getters.devicesDateCompare
			},

			allSensors () {
				return this.$store.getters.allSensors
			},

			projects() {
				return this.$store.getters.projects
			},

			showProjects() {
				return this.projects.length > 0
			},
		},

		watch: {
			devicesDateCompare (val) {
				this.dataCharts(val)
			},

			selectProject(val){
				const deviceByProject = this.devices.filter ( e => e.projectId === val)
				this.selectDevices = deviceByProject.map( e => e.deviceId )
			}
		},

		filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LL')
			},
		},

		components: {
			apexchart: VueApexCharts
		},

		created () {

			moment.locale('es-us')
		}
	}
</script>
